import { render } from "./createPaybill.vue?vue&type=template&id=6f46f7a6&scoped=true"
import script from "./createPaybill.vue?vue&type=script&lang=js"
export * from "./createPaybill.vue?vue&type=script&lang=js"

import "./createPaybill.vue?vue&type=style&index=0&id=6f46f7a6&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f46f7a6"]])

export default __exports__